/** Step shell — flex-column layout wrapper shared by all step type components. */
import type { ReactNode } from 'react';

interface StepShellProps {
  children: ReactNode;
}

/**
 * Layout wrapper for all step types.
 * Provides a flex column container with flexible growth.
 */
export function StepShell({ children }: StepShellProps) {
  return <div className="flex min-h-0 flex-1 flex-col">{children}</div>;
}
